// Content migrated to Step2VerifyIdentity and FileUploadZone (Step 4) in GuideSignupFlow.jsx (SCRUM-1862)
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const GuideVerification = () => {
  const navigate = useNavigate();
  useEffect(() => { navigate('/guides/signup', { replace: true }); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
};

export default GuideVerification;
